import axiosInstance from "./axiosInstance";

export const signup = async (userData) => {
  try {
    const res = await axiosInstance.post("/signup", userData);
    return res.data;
  } catch (error) {
    console.error("Error during signup:", error);
    throw error;
  }
};

export const login = async (credentials) => {
  try {
    const res = await axiosInstance.post("/login", credentials);
    const data = res.data;

    if (data.success && data.user) {
      localStorage.setItem("user", JSON.stringify(data.user));
    }

    return data;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export const instructorLogin = async (credentials) => {
  try {
    const res = await axiosInstance.post("/instructor-login", credentials);
    const data = res.data;

    if (data.success && data.user) {
      localStorage.setItem("user", JSON.stringify(data.user));
    }

    return data;
  } catch (error) {
    console.error("Error during instructor login:", error);
    throw error;
  }
};

export const hrLogin = async (credentials) => {
  try {
    const res = await axiosInstance.post("/hr-login", credentials);
    const data = res.data;

    if (data.success && data.user) {
      localStorage.setItem("user", JSON.stringify(data.user));
    }

    return data;
  } catch (error) {
    console.error("Error during HR login:", error);
    throw error;
  }
};

export const logout = async () => {
  try {
    const res = await axiosInstance.get("/logout");
    localStorage.removeItem("user");
    localStorage.removeItem("tokenExpiry");
    return res.data;
  } catch (error) {
    console.error("Error during logout:", error);
    throw error;
  }
};

export const getProfile = async () => {
  try {
    const res = await axiosInstance.get("/profile");
    return res.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const isAuthenticated = () => {
  const user = localStorage.getItem("user");
  return !!user;
};

export const getCurrentUser = () => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("Error parsing user from localStorage:", error);
    return null;
  }
};

export const clearAuth = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("tokenExpiry");
};

export const createUserProfile = async (profileData) => {
  try {
    const res = await axiosInstance.post("/userProfile", profileData);
    return res.data;
  } catch (error) {
    console.error("Error creating user profile:", error);
    throw error;
  }
};

export const fetchUserProfileById = async (userId) => {
  try {
    const res = await axiosInstance.get(`/getpersonalinfo?userId=${userId}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const getCandidatebyUserId = async (userId) => {
  try {
    const res = await axiosInstance.get(`/studentprofile/${userId}`);
    return res.data.student;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};


